import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState } from 'store/auth/userSlice'
import {
    apiSignIn,
    apiSignOut,
    apiSignUp,
    apiGetRolePermissions,
    apiGetThemeInfoByUnqid,
    apiGetOperaterSettingsID,
    apiGetBrandInfo,
    apiFetchDealerSpocData,
    apiGetDistrictsTerritorryPoints,
} from 'services/AuthService'
import { onFirstLogin, onSignInSuccess, onSignOutSuccess, setDashboardPermissions, setTabLevelPermissions, setUserCategory } from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import { REDIRECT_URL_KEY } from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'
import navigationConfigFile from 'configs/navigation.config'
import { NAV_ITEM_TYPE_COLLAPSE } from 'constants/navigation.constant'
import _ from 'lodash'
import { OpenNotification } from 'views/Servicefile'
import useDarkMode from 'utils/hooks/useDarkMode'
import useDirection from './useDirection'
import { setDateFormat, setLang, setLargeLogo, setSmallLogo, setThemeLargeLogo, setThemeSmallLogo } from 'store/locale/localeSlice'
import { setSideNavCollapse } from 'store/theme/themeSlice'
import { setSelectedTab } from 'views/Displaytickets/store/dataSlice'
import { userRoles } from 'utils/constants'
import { fetchDefaultMenuURL } from './MenuItems'
import { saveDistricts } from '../../views/db';

function useAuth() {

    const [isDark, setIsDark] = useDarkMode()
    const [direction, updateDirection] = useDirection()


    const dispatch = useDispatch()

    const navigate = useNavigate()

    const query = useQuery()

    const { token, signedIn, accUnqId, userCategory } = useSelector((state) => state.auth.session)



    const getUserSpecificMenus = async (permissions, category) => {
        // const { permissions } = useSelector((state) => state.auth.user)

        console.log(navigationConfigFile)
        const allPermissions = _.flatMap(permissions?.module_dto, (module) => {
            return _.flatMap(module.sub_module_dto, (subModule) => {
                return {
                    module: module.code,
                    subModule: subModule.code,
                    permission: subModule.td_permissions_resp_dto,
                }
            })
        })
        console.log(allPermissions)
        const enabledPermissions = _.filter(allPermissions, (modulerow) => {
            if (
                modulerow.permission.filter((f) => f.enabled === true).length >
                0
            ) {
                modulerow.permission = modulerow.permission.filter(
                    (f) => f.enabled === true
                )
                return true
            } else {
                return false
            }
        })
        console.log(enabledPermissions)
        let moduleList = enabledPermissions.map((e) => e.module)
        // let submoduleList = enabledPermissions.map((e) => e.subModule)
        let submoduleList = [...moduleList, ...enabledPermissions.map((e) => e.subModule)];
        // moduleList.push('DASHBOARD')
        //submoduleList.push('PBR')

        //needed this as there was a problem with menus not loading.
        let file = _.cloneDeep(navigationConfigFile)

        let listOfModulesFiltered = file.filter((module) => {

            if (['/viewtickets'].includes(module.path) && category === "PLATFORM_ADMIN") {
                return false
            }
            if (category === "BUSINESS_ADMIN" || module.code === 'DEF' || moduleList.includes(module.code)) {
                if (module.type === NAV_ITEM_TYPE_COLLAPSE && module.subMenu && Array.isArray(module.subMenu)) {
                    if (category !== "BUSINESS_ADMIN") {
                        module.subMenu = module.subMenu.filter((sub) => {
                            return submoduleList.includes(sub.code)
                        })
                        if (module.subMenu.length === 0) {
                            return false
                        }
                    }
                }

                return true
            } else {
                return false
            }
        })

        let permissionsList = enabledPermissions.map((e) =>
            e.permission.map((x) => x.code)
        )
        permissionsList = permissionsList ? permissionsList.flat() : []

        if (category === "BUSINESS_ADMIN" || listOfModulesFiltered.length === 0) {
            listOfModulesFiltered = file;
        }

        return { navigationConfig: listOfModulesFiltered, permissionsList }
    }

    // const signIn = async (values) => {
    //     try {
    //         const resp = await apiSignIn(values)

    //         if (resp.data) {
    //             const { access_token, user_name, acc_unq_id, role_name } =
    //                 resp.data
    //             dispatch(onSignInSuccess(access_token))
    //             const permissions = await apiGetRolePermissions({
    //                 //roleId: values.unq_id,

    //                 roleId: acc_unq_id,
    //             })

    //             let menuObject = await getUserSpecificMenus(permissions.data)

    //             //  if (resp.data.user) {
    //             dispatch(
    //                 setUser({
    //                     ...values,
    //                     user_name,
    //                     role_name,
    //                     permissionsList: menuObject.permissionsList,
    //                     navigationConfig: menuObject.navigationConfig,
    //                 })
    //             )

    //             //  }
    //             const redirectUrl = query.get(REDIRECT_URL_KEY)
    //             navigate(
    //                 redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath
    //             )
    //             return {
    //                 status: 'success',
    //                 message: '',
    //             }
    //         }
    //     } catch (errors) {
    //         return {
    //             status: 'failed',
    //             message: errors?.response?.data?.message || errors.toString(),
    //         }
    //     }
    // }

    const fetchDistrictData = async (company_code) => {
        try {
            const applyFilteredData = [
                { fieldName: "dealer_code", type: "LIST", value: [company_code] },
            ];
            const filteredData = applyFilteredData.filter(item => (item.value && item.value.length > 0));
            const allVehiclesarams = new URLSearchParams({
                filter: JSON.stringify(filteredData)
            });

            const resp = await apiGetDistrictsTerritorryPoints(allVehiclesarams);
            const districtData = resp?.data?.response?.res || [];
            console.log(districtData)
            console.log(resp);
            if (!resp?.data?.success) throw new Error('Failed to fetch');
            //const data = await response.json();
            const formatted = districtData?.map((item) => ({
                DistrictName: item.district,
                Polygon: item.boundary,
            }));
            await saveDistricts(formatted);
        } catch (error) {
            console.error('Error syncing districts:', error);
        }
    };

    const FetchDealerSpocDetails = async (email) => {
        try {
            const res = await apiFetchDealerSpocData(email)
            //console.log('API Response:', res)

            if (res?.data?.success) {
                const dealerDetails = res.data?.response || {}
                localStorage.setItem('PlantCodes', JSON.stringify(dealerDetails));
                //setDealerSpocDetails(dealerDetails)

                //fetchDistrictData(dealerDetails?.company_codes[0]);
                console.log('Dealer SPOC Details:', dealerDetails)
                // if (role_type === userRoles.DEALER_SPOC_MANAGER) {
                //     fetchTickets(dealerDetails)
                // }
            } else {
                console.warn(
                    'API call unsuccessful:',
                    res?.data?.message || 'Unknown error'
                )
            }
        } catch (error) {
            console.error('Failed to fetch dealer SPOC details:', error)
        }
    }
    const signIn = async (values, flag) => {
        if (flag) {
            try {
                const resp = await apiSignIn(values)
                // if (resp.data.firsttime_login === true){
                //     const {
                //         access_token,
                //         user_name,
                //         acc_unq_id,
                //         role_name,
                //         acc_mno_id,
                //         acc_user_id,
                //         acc_mno_parent_unq_id,
                //         acc_mno_parent_id,
                //         user_type,
                //         unq_id,
                //         profile_img_url,
                //         acc_mno_unq_id
                //     } = resp.data

                //     // Dispatch the onSignInSuccess action
                //     await dispatch(
                //         onFirstLogin({
                //             access_token: access_token,
                //             acc_unq_id: acc_unq_id
                //         })
                //     );



                //    const permissions = await apiGetRolePermissions({
                //         roleId: acc_unq_id,
                //     })

                //     let menuObject = await getUserSpecificMenus(permissions.data)


                //     // let themeSettings = await apiGetThemeInfoByUnqid(unq_id)
                //     // // SET THE THEMES

                //     // let genSettings = await apiGetOperaterSettingsID(unq_id)

                //     // //check if there is atleast one record , then only apply settings..
                //     // if(themeSettings.data.response.length>0)
                //     // {
                //     //     let darkMode=themeSettings.data.response[themeSettings.data.response.length-1].thm_mode;

                //     //     setIsDark(darkMode ? 'dark' : 'light')
                //     // }

                //     // //applying direction
                //     // if(themeSettings.data.response.length>0){
                //     //     let direction=themeSettings.data.response[themeSettings.data.response.length-1].thm_orientation;
                //     //     updateDirection(direction)
                //     // }
                //     // let dateFormat;
                //     // if(genSettings?.data?.response.length>0){
                //     //     let lang = genSettings?.data.response[genSettings?.data.response.length-1].gen_set_lang_pref
                //     //     dispatch(setLang(lang))
                //     //     dateFormat = genSettings?.data.response[genSettings?.data.response.length-1].gen_set_date_format
                //     //     dispatch(setDateFormat(dateFormat))
                //     // }

                //     // //brand info logos
                //     // let brandInfo = await apiGetBrandInfo(acc_mno_unq_id)
                //     // if(brandInfo?.data?.response.length>0){
                //     //     let logo=brandInfo.data.response[brandInfo.data.response.length-1];
                //     //     dispatch(setLargeLogo(logo.large_logo_url))
                //     //     dispatch(setSmallLogo(logo.small_logo_url))
                //     //     dispatch(setThemeLargeLogo(logo.thm_large_logo_url))
                //     //     dispatch(setThemeSmallLogo(logo.thm_small_logo_url))
                //     // }

                //     // // Dispatch the setUser action
                //     await dispatch(
                //         setUser({
                //             ...values,
                //             user_name,
                //             role_name,
                //             acc_mno_id,
                //             acc_user_id,
                //             acc_unq_id,

                //             profile_img_url,
                //             permissionsList: menuObject.permissionsList,
                //             navigationConfig: menuObject.navigationConfig,
                //             user_type,
                //             unq_id
                //         })
                //     )

                //     await navigate('/change-password')


                //     return {
                //         status: 'success',
                //         message: '',
                //     }
                // }
                // else {
                const {
                    access_token,
                    user_name,
                    acc_unq_id,
                    role_name,
                    acc_mno_id,
                    acc_user_id,
                    acc_mno_parent_unq_id,
                    acc_mno_parent_id,
                    user_type,
                    unq_id,
                    profile_img_url,
                    acc_mno_unq_id,
                    refresh_token,
                    default_sub_mod_code,
                } = resp.data


                // Dispatch the onSignInSuccess action
                await dispatch(
                    onSignInSuccess({
                        access_token: access_token,
                        acc_unq_id: acc_unq_id,
                        refresh_token: refresh_token,

                    })
                );

                const userRoleCategory = resp?.data?.user_role_category || 'BUSINESS_ADMIN'
                const roleName = resp?.data?.role_name || 'BUSINESS_ADMIN'
                dispatch(setUserCategory(userRoleCategory))
                let permissions = null
                try {
                    permissions = await apiGetRolePermissions({
                        roleId: acc_unq_id,
                    })
                } catch (permError) {
                    console.warn("apiGetRolePermissions failed, falling back to full permissions:", permError)
                }
                if (!permissions || !permissions.data) {
                    permissions = { data: { module_dto: [] } }
                }
                let tabLevelPermissionsData = permissions?.data?.module_dto || [];
                permissions?.data?.module_dto?.push({
                    "title": "Default",
                    "code": "DEF",
                    "description": "Default Module",
                    "sub_module_dto": [
                        {
                            "title": "DEF subModule",
                            "code": "DEFSUB",
                            "description": null,
                            "td_permissions_resp_dto": [
                                {
                                    "title": "MENU",
                                    "code": "DEFHQDMEN",
                                    "enabled": true
                                },
                                {
                                    "title": "VIEW",
                                    "code": "DEFHQDVIE",
                                    "enabled": true
                                },
                                {
                                    "title": "ADD",
                                    "code": "DEFHQDADD",
                                    "enabled": true
                                },
                                {
                                    "title": "EDIT",
                                    "code": "DEFHQDEDI",
                                    "enabled": true
                                },
                                {
                                    "title": "DEACTIVE",
                                    "code": "DEFHQDDEA",
                                    "enabled": false
                                },
                                {
                                    "title": "Default",
                                    "code": "DEFHQDDef",
                                    "enabled": false
                                }
                            ]
                        }
                    ]
                })
                const getAllPermissionCodes = (data) => {
                    let codes = [];

                    data.forEach(module => {
                        if (module.sub_module_dto) {
                            module.sub_module_dto.forEach(subModule => {

                                // ✅ Filter only enabled permissions
                                if (subModule.td_permissions_resp_dto) {
                                    subModule.td_permissions_resp_dto.forEach(perm => {
                                        if (perm.enabled) codes.push(perm.code);
                                    });
                                }

                                if (subModule.sub_module_tab_resp_dto) {
                                    subModule.sub_module_tab_resp_dto.forEach(subTab => {
                                        if (subTab.td_permissions_resp_dto) {
                                            subTab.td_permissions_resp_dto.forEach(perm => {
                                                if (perm.enabled) codes.push(perm.code);
                                            });
                                        }
                                    });
                                }
                            });
                        }

                        // ✅ Handle if `td_permissions_resp_dto` exists directly under module
                        if (module.td_permissions_resp_dto) {
                            module.td_permissions_resp_dto.forEach(perm => {
                                if (perm.enabled) codes.push(perm.code);
                            });
                        }
                    });

                    return codes;
                };

                // ✅ Usage
                const allEnabledCodes = getAllPermissionCodes(tabLevelPermissionsData);
                console.log("allEnabledCodes", allEnabledCodes);
                dispatch(setTabLevelPermissions(allEnabledCodes))
                dispatch(setDashboardPermissions(permissions))
                let menuObject = await getUserSpecificMenus(permissions.data, userRoleCategory)

                // let themeSettings = await apiGetThemeInfoByUnqid(unq_id)
                // // SET THE THEMES

                // let genSettings = await apiGetOperaterSettingsID(unq_id)

                // //check if there is atleast one record , then only apply settings..
                // if(themeSettings.data.response.length>0)
                // {
                //     let darkMode=themeSettings.data.response[themeSettings.data.response.length-1].thm_mode;

                //     setIsDark(darkMode ? 'dark' : 'light')
                // }

                // //applying direction
                // if(themeSettings.data.response.length>0){
                //     let direction=themeSettings.data.response[themeSettings.data.response.length-1].thm_orientation;
                //     updateDirection(direction)
                // }
                // let dateFormat;
                // if(genSettings?.data?.response.length>0){
                //     let lang = genSettings?.data.response[genSettings?.data.response.length-1].gen_set_lang_pref
                //     dispatch(setLang(lang))
                //     dateFormat = genSettings?.data.response[genSettings?.data.response.length-1].gen_set_date_format
                //     dispatch(setDateFormat(dateFormat))
                // }

                // //brand info logos
                // let brandInfo = await apiGetBrandInfo(acc_mno_unq_id)
                // if(brandInfo?.data?.response.length>0){
                //     let logo=brandInfo.data.response[brandInfo.data.response.length-1];
                //     dispatch(setLargeLogo(logo.large_logo_url))
                //     dispatch(setSmallLogo(logo.small_logo_url))
                //     dispatch(setThemeLargeLogo(logo.thm_large_logo_url))
                //     dispatch(setThemeSmallLogo(logo.thm_small_logo_url))
                // }

                // Dispatch the setUser action
                await dispatch(
                    setUser({
                        ...values,
                        user_name,
                        role_name,
                        acc_mno_id,
                        acc_user_id,
                        acc_unq_id,
                        acc_mno_parent_unq_id,
                        acc_mno_parent_id,
                        profile_img_url,
                        permissionsList: menuObject.permissionsList,
                        navigationConfig: menuObject.navigationConfig,
                        user_type,
                        acc_mno_unq_id
                    })
                )
                console.log(userRoleCategory)
                if (userRoleCategory === userRoles.DEALER_SPOC_MANAGER || userRoleCategory === userRoles.DEALER_SPOC || userRoleCategory === userRoles.DEALER_GENERAL_MANAGER) {
                    FetchDealerSpocDetails(values.email)
                } else {
                    localStorage.removeItem("PlantCodes")

                }
                //console.log(permissions.data)
                console.log(default_sub_mod_code)
                //let prrdata = permissions?.data?.module_dto;
                let defaultMenuCode = "Home";
                // prrdata?.map(prrItem => {
                //     prrItem?.sub_module_dto?.map(subItem => {
                //         if (subItem?.td_permissions_resp_dto[5]?.enabled) {
                //             defaultMenuCode = subItem.code;
                //         }
                //     })
                // })
                if (default_sub_mod_code) {
                    defaultMenuCode = default_sub_mod_code;
                }
                let redirectUrl = await fetchDefaultMenuURL(defaultMenuCode)
                // setTimeout(() => {
                //     redirectUrl = "/operationsMenu-menu-item2"
                // }, 2000)
                await dispatch(setSelectedTab("All"))
                console.log(redirectUrl)
                await navigate(
                    redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath
                )


                return {
                    status: 'success',
                    message: '',
                }
                // }
            } catch (errors) {
                const errorData = errors?.response?.data
                const errorMsg =
                    errorData?.error?.error_msg ||
                    (typeof errorData?.error === 'string' ? errorData?.error : null) ||
                    errorData?.message ||
                    errors?.message ||
                    errors?.toString()

                return {
                    status: 'failed',
                    error: errorData?.error || null,
                    message: errorMsg,
                }
            }

        } else {
            try {
                if (values) {
                    const {
                        access_token,
                        user_name,
                        acc_unq_id,
                        role_name,
                        acc_mno_id,
                        acc_user_id,
                        acc_mno_parent_unq_id,
                        acc_mno_parent_id,
                        user_type,
                        unq_id,
                        profile_img_url,
                        acc_mno_unq_id,
                        refresh_token,
                        default_sub_mod_code,
                    } = values.data

                    // Dispatch the onSignInSuccess action
                    await dispatch(
                        onSignInSuccess({
                            access_token: access_token,
                            acc_unq_id: acc_unq_id,
                            refresh_token: refresh_token,

                        })
                    );

                    const userRoleCategory = values?.data?.user_role_category || 'BUSINESS_ADMIN'
                    const roleName = values?.data?.role_name || 'BUSINESS_ADMIN'
                    dispatch(setUserCategory(userRoleCategory))
                    let permissions = null
                    try {
                        permissions = await apiGetRolePermissions({
                            roleId: acc_unq_id,
                        })
                    } catch (permError) {
                        console.warn("apiGetRolePermissions failed, falling back to full permissions:", permError)
                    }
                    if (!permissions || !permissions.data) {
                        permissions = { data: { module_dto: [] } }
                    }
                    let tabLevelPermissionsData = permissions?.data?.module_dto || [];

                    permissions?.data?.module_dto?.push({
                        "title": "Default",
                        "code": "DEF",
                        "description": "Default Module",
                        "sub_module_dto": [
                            {
                                "title": "DEF subModule",
                                "code": "DEFSUB",
                                "description": null,
                                "td_permissions_resp_dto": [
                                    {
                                        "title": "MENU",
                                        "code": "DEFHQDMEN",
                                        "enabled": true
                                    },
                                    {
                                        "title": "VIEW",
                                        "code": "DEFHQDVIE",
                                        "enabled": true
                                    },
                                    {
                                        "title": "ADD",
                                        "code": "DEFHQDADD",
                                        "enabled": true
                                    },
                                    {
                                        "title": "EDIT",
                                        "code": "DEFHQDEDI",
                                        "enabled": true
                                    },
                                    {
                                        "title": "DEACTIVE",
                                        "code": "DEFHQDDEA",
                                        "enabled": true
                                    },
                                    {
                                        "title": "Default",
                                        "code": "DEFHQDDef",
                                        "enabled": false
                                    }
                                ]
                            }
                        ]
                    })
                    const getAllPermissionCodes = (data) => {
                        let codes = [];

                        data.forEach(module => {
                            if (module.sub_module_dto) {
                                module.sub_module_dto.forEach(subModule => {

                                    // ✅ Filter only enabled permissions
                                    if (subModule.td_permissions_resp_dto) {
                                        subModule.td_permissions_resp_dto.forEach(perm => {
                                            if (perm.enabled) codes.push(perm.code);
                                        });
                                    }

                                    if (subModule.sub_module_tab_resp_dto) {
                                        subModule.sub_module_tab_resp_dto.forEach(subTab => {
                                            if (subTab.td_permissions_resp_dto) {
                                                subTab.td_permissions_resp_dto.forEach(perm => {
                                                    if (perm.enabled) codes.push(perm.code);
                                                });
                                            }
                                        });
                                    }
                                });
                            }

                            // ✅ Handle if `td_permissions_resp_dto` exists directly under module
                            if (module.td_permissions_resp_dto) {
                                module.td_permissions_resp_dto.forEach(perm => {
                                    if (perm.enabled) codes.push(perm.code);
                                });
                            }
                        });

                        return codes;
                    };
                    const allEnabledCodes = getAllPermissionCodes(tabLevelPermissionsData);
                    console.log("allEnabledCodes", allEnabledCodes);
                    dispatch(setTabLevelPermissions(allEnabledCodes))
                    dispatch(setDashboardPermissions(permissions))
                    let menuObject = await getUserSpecificMenus(permissions.data, userRoleCategory)

                    // Dispatch the setUser action
                    await dispatch(
                        setUser({
                            ...values.data,
                            user_name,
                            role_name,
                            acc_mno_id,
                            acc_user_id,
                            acc_unq_id,
                            acc_mno_parent_unq_id,
                            acc_mno_parent_id,
                            profile_img_url,
                            permissionsList: menuObject.permissionsList,
                            navigationConfig: menuObject.navigationConfig,
                            user_type,
                            acc_mno_unq_id
                        })
                    )
                    console.log(userRoleCategory)
                    if (userRoleCategory === userRoles.DEALER_SPOC_MANAGER || userRoleCategory === userRoles.DEALER_SPOC || userRoleCategory === userRoles.DEALER_GENERAL_MANAGER) {
                        FetchDealerSpocDetails(values.data.email)
                    } else {
                        localStorage.removeItem("PlantCodes")

                    }

                    console.log(default_sub_mod_code)
                    //let prrdata = permissions?.data?.module_dto;
                    let defaultMenuCode = "HQD";
                    // prrdata?.map(prrItem => {
                    //     prrItem?.sub_module_dto?.map(subItem => {
                    //         if (subItem?.td_permissions_resp_dto[5]?.enabled) {
                    //             defaultMenuCode = subItem.code;
                    //         }
                    //     })
                    // })
                    if (default_sub_mod_code) {
                        defaultMenuCode = default_sub_mod_code;
                    }
                    let redirectUrl = await fetchDefaultMenuURL(defaultMenuCode)
                    await dispatch(setSelectedTab("All"))
                    await navigate(
                        redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath
                    )


                    return {
                        status: 'success',
                        message: '',
                    }
                }
            } catch (errors) {


                return {
                    status: 'failed',
                    error: errors.response.data.error,
                    message: errors?.response?.data?.error.error_msg || errors.toString(),
                }
            }

        }



    }

    const signUp = async (values) => {
        try {
            const resp = await apiSignUp(values)
            if (resp.data) {

                const { token } = resp.data
                dispatch(onSignInSuccess(token))
                if (resp.data.user) {
                    dispatch(
                        setUser(
                            resp.data.user || {
                                avatar: '',
                                userName: 'Anonymous',
                                authority: ['USER'],
                                email: '',
                            }
                        )
                    )
                }
                const redirectUrl = query.get(REDIRECT_URL_KEY)
                navigate(
                    redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath
                )
                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const handleSignOut = () => {
        dispatch(onSignOutSuccess())
        dispatch(setUser(initialState))
        navigate(appConfig.unAuthenticatedEntryPath)
        localStorage.clear();
    }

    const signOut = async () => {
        try {
            const iframewidget = document.getElementById('dialer-widget');
            if (iframewidget && iframewidget.contentWindow) {
                console.log("LoggedOut Successfully")
                iframewidget.contentWindow.postMessage(`agentstatus|logout`, "*");
            }
            await apiSignOut()
            handleSignOut()
            dispatch(setSideNavCollapse(false))
        } catch (err) {
            handleSignOut()
            dispatch(setSideNavCollapse(false))
        }


    }


    return {
        authenticated: token && accUnqId && signedIn,
        signIn,
        signUp,
        signOut,
    }
}


export default useAuth